function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useState } from 'react';
const useAccordion = _ref => {
  let {
    initialExpanded = [0],
    multiExpand,
    itemCount
  } = _ref;
  const getExpandedItems = useCallback(() => initialExpanded.length > 1 && !multiExpand ? [Math.min(...initialExpanded)] : initialExpanded, [initialExpanded, multiExpand]);
  const [expandedItems, setExpandedItems] = useState(itemCount > 0 && initialExpanded.length === 0 ? [] : getExpandedItems());
  const expandItem = useCallback(index => {
    if (!multiExpand) {
      setExpandedItems([index]);
    } else {
      setExpandedItems([index, ...expandedItems]);
    }
  }, [expandedItems, multiExpand]);
  const onClick = useCallback((e, index) => {
    e.preventDefault();
    e.stopPropagation();
    if (expandedItems.includes(index)) {
      setExpandedItems(expandedItems.filter(i => i !== index));
    } else {
      expandItem(index);
    }
  }, [expandItem, expandedItems]);
  const getItemProps = useCallback(_ref2 => {
    let {
      index
    } = _ref2;
    const buttonId = `accordion-item-${index}-button`;
    const containerId = `accordion-item-${index}-container`;
    const buttonProps = {
      id: buttonId,
      'aria-controls': containerId
    };
    const containerProps = _objectSpread({
      id: containerId
    }, (!multiExpand || itemCount <= 6) && {
      role: 'region',
      /**
       * aria-labelledby attribute is not well-supported on a div with no valid role attribute
       * so only add this if we are also adding the role
       */
      'aria-labelledby': buttonId
    });
    return {
      expanded: expandedItems.includes(index),
      onExpand: e => onClick(e, index),
      buttonProps,
      containerProps
    };
  }, [expandedItems, itemCount, multiExpand, onClick]);
  return {
    getItemProps,
    expandedItems,
    expandItem
  };
};
export default useAccordion;
//# sourceMappingURL=useAccordion.js.map